import { captureException, withScope } from '@sentry/react'
import { CanceledError } from 'axios'

export const captureError = ({ error, extras }: { error: any; extras?: Record<string, any> }) => {
  if (error instanceof CanceledError) {
    return
  }

  const axiosDefaultFields = {
    errors: error?.response?.errors,
    status: error?.response?.status,
    statusText: error?.response?.statusText,
    errorResponseData: error?.response?.data,
  }

  const sanitizedExtras = { ...extras, axios: axiosDefaultFields }

  console.group(`[ERROR] ${error.name}`)
  console.error(error)
  extras && console.log(`Error extras:\n\n`, JSON.stringify(sanitizedExtras, null, 2))
  console.groupEnd()

  withScope((scope) => {
    extras && scope.setExtras({ extras: JSON.stringify(sanitizedExtras, null, 2) })
    captureException(new Error(error), scope)
  })
}
